import { apiClient } from "services/api-client"

export const getDatas = async (tenant) => {
    return await apiClient.get(`/mapping/data?companyKey=${tenant}`)
}

export const getDatasPaged = async (tenant, page, perPage) => {
    return await apiClient.get(`/mapping/data/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}`)
}

export const getDatasNames = async (tenant) => {
    return await apiClient.get(`/mapping/data/names?companyKey=${tenant}`)
}

export const getDataById = async (id) => {
    return await apiClient.get(`/mapping/data/${id}`)
}

export const addData = async (data) => {
    return await apiClient.post('/mapping/data', data)
}

export const editData = async (id, data) => {
    return await apiClient.put(`/mapping/data/${id}`, data)
}

export const deleteData = async (id) => {
    return await apiClient.delete(`/mapping/data/${id}`)
}